import React from 'react';

const FilterBar = ({ dateRange, setDateRange, communeFilter, setCommuneFilter, communes }) => {
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '15px 20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            margin: '10px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
            alignItems: 'center'
        }}>
            <div>
                <label style={{ marginRight: '10px', fontWeight: '500' }}>Periode :</label>
                <select 
                    value={dateRange} 
                    onChange={(e) => setDateRange(e.target.value)}
                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                    <option value="7">7 derniers jours</option>
                    <option value="30">30 derniers jours</option>
                    <option value="90">90 derniers jours</option>
                    <option value="365">Derniere annee</option>
                    <option value="all">Toute la periode</option>
                </select>
            </div>
            
            <div>
                <label style={{ marginRight: '10px', fontWeight: '500' }}>Commune :</label>
                <select 
                    value={communeFilter} 
                    onChange={(e) => setCommuneFilter(e.target.value)}
                    style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                    <option value="all">Toutes les communes</option>
                    {communes.map(c => (
                        <option key={c.commune} value={c.commune}>{c.commune}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default FilterBar;